/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type CartItems_localItems$ref = any;
export type CartLayout_localItems$ref = any;
export type CartLayout_localItems = {
    readonly totalResults: number | null;
    readonly " $fragmentRefs": CartItems_localItems$ref;
    readonly " $refType": CartLayout_localItems$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CartLayout_localItems",
    "type": "ItemsConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "totalResults",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "FragmentSpread",
            "name": "CartItems_localItems",
            "args": null
        }
    ]
} as any);
(node as any).hash = '007f8d6c22ca3928fac0139bc9988fea';
export default node;
